const GanttChart = () => {

    const years = ["2016", "2019", "2021", "2023"];

    const descriptions = [
        "City of Memphis launched a comprehensive planning process",
        "Adoption of the Memphis 3.0 Comprehensive Plan - The cities first major plan since 1981",
        "Accelerate Memphis announced",
        "Activating Memphis 3.0 through Accelerate Memphis initiative"
    ];

    return (
        <div className="relative w-full px-4 h-32 flex flex-col items-center justify-center">
            {/* Horizontal Bar */}
            <div className="w-full h-1 bg-black" />

            <div className="flex justify-between w-full -mt-3 px-4">
                {years.map((year, index) => (
                    <div key={index} className="flex flex-col items-center">
                        {/* Dot - Centered on the bar */}
                        <div className={`w-6 h-6 ${index === years.length - 1 ? 'bg-gray-400' : 'bg-blue-500'} rounded-full border-4 border-black shadow-md`} />
                        {/* Year */}
                        <span className="mt-2 text-memphis-blue font-bold">{year}</span>
                        {/* Description */}
                        <span className="mt-1 text-xs max-w-[200px] text-center text-gray-600">
                            {descriptions[index]}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GanttChart;
